import * as yup from "yup";
export const yupChangeAccountDescriptionInput = yup.object({
    AccountId: yup.string().required(),
    Name: yup.string().required().min(1),
});
